module.exports = __webpack_public_path__ + "img/image-title3.473685bb.svg";